import React from 'react';
import { withNamespaces } from 'react-i18next';

const AchTransactionsView = () => {
  return <div>AchTransactionsView</div>;
};

export default withNamespaces()(AchTransactionsView);
